"use client";

import { createContext, ReactNode, useContext } from "react";

const WorkspaceApplicationsContext = createContext<ReadonlySet<string> | null>(null);

export function WorkspaceApplicationsProvider({
  children,
  effectiveAppCodes,
}: {
  children: ReactNode;
  effectiveAppCodes: ReadonlySet<string>;
}) {
  return (
    <WorkspaceApplicationsContext.Provider value={effectiveAppCodes}>
      {children}
    </WorkspaceApplicationsContext.Provider>
  );
}

export function useEffectiveWorkspaceAppCodes(): ReadonlySet<string> {
  const effectiveAppCodes = useContext(WorkspaceApplicationsContext);

  if (!effectiveAppCodes) {
    throw new Error("useEffectiveWorkspaceAppCodes must be used inside WorkspaceApplicationsProvider.");
  }

  return effectiveAppCodes;
}
